import { AnimatePresence } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import animations from '../../helpers/animations';
import {
    BackgroundModal,
    CloseModalButton,
    ModalContent,
    ModalTitle,
    ModalWrapper,
} from './styles';

import { MdPix } from 'react-icons/md';

import { usePaymentModalStore } from '../../store/payment/paymentModalStore';
import CopyCode from './pieces/CopyCode';
import QrCountdown from './pieces/QrCountdown';
import QrInfo from './pieces/QrInfo';

export function ModalPaymentPix() {
    const [ canClose, setCanClose ] = useState<boolean>(false);
    const modalRef = useRef<HTMLDivElement | null>(null);
    const paymentModal = usePaymentModalStore();

    useEffect(() => {
        setCanClose(
            paymentModal.status === 'FAILED' ||
            paymentModal.status === 'EXPIRED' ?
            true : false
        );
    }, [paymentModal, canClose]);

    return (
        <AnimatePresence>
            {paymentModal.isVisible && paymentModal.method === 'pix' && (
                <BackgroundModal
                    ref={modalRef}
                    {...animations.fadeInOut(0.1)}
                    onClick={
                        canClose ?
                        paymentModal.close
                        : () => null
                    }
                >
                    <ModalWrapper onClick={e => e.stopPropagation()}>
                        <>
                            <ModalTitle>
                                <MdPix className="icon" color="#32BCAD" />
                                <p>Pague com Pix</p>
                            </ModalTitle>
                            {
                                canClose ?
                                <CloseModalButton
                                    onClick={paymentModal.close}
                                /> : ''
                            }
                        </>
                        <ModalContent>
                            <QrCountdown
                                endDate={new Date(paymentModal.response!.expiresAt)}
                                codeString={paymentModal.response!.qrCode!}
                                transactionStatus={paymentModal.status}
                            />
                            <CopyCode codeText={paymentModal.response!.qrCode!} />
                            <QrInfo />
                        </ModalContent>
                    </ModalWrapper>
                </BackgroundModal>
            )}
        </AnimatePresence>
    );
}